export default __webpack_public_path__ + "static/FooterMenuContactMenuSocialsCopyrightBottomMenuWithLogo-d711edc3f8212109f60a260880c70929.jpg";